import TransformComponent from '../../Component/Transform';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Point from '../../Utility/Point';
import Text from '../Text';
import { TextStyleOptions } from 'pixi.js';
import Renderable from '../../Component/Renderable';

export default class SpeechBubble {
    public readonly root: GameObject;

    constructor(params: {
        speechBubbleRoot: Sprite;
        text: string;
        textStyle: TextStyleOptions;
        visible?: boolean;
    }) {
        // Add the base sprite.
        this.root = params.speechBubbleRoot;
        this.root.getComponent(Renderable).visible = true;
        this.root.getComponent(Renderable).alpha = 0;

        // Add the message.
        const message: Text = GameObject.Instantiate(Text, {
            position: new Point(0, -70),
            anchor: new Point(0.5, 0.5),
            bounds: new Point(170, 70),
            text: params.text,
            style: params.textStyle,
        });
        message.getComponent(TransformComponent).rotation = -this.root.getComponent(TransformComponent).rotation;
        this.root.addChild(message);
    }

    public isUp(): boolean {
        const rotation = this.root.getComponent(TransformComponent).rotation % (Math.PI * 2);
        return rotation < Math.PI && rotation > -Math.PI;
    }
}
